import React from 'react';
import { Box } from '@mui/material';
import { Outlet, useLocation, useNavigate } from 'react-router';
import Topbar from "../../../../../../component/TopBar";
import MainBox from "../../../../container/MainBox";
import { SettingsHeader, SettingsLayout } from "../../../../../../component/settings";

/**
 * Timesheet configuration, in the shape the module-screens book gives every
 * settings page: groups on the left, one column of fields on the right.
 *
 * These four pages existed as routes with no navigation between them — the only
 * way to reach Client or Employee rate was to know the URL.
 */
const BASE = "/app/timesheet-settings";

const GROUPS = [
  { key: "", label: "Time log" },
  { key: "employee-rate", label: "Employee rate" },
  { key: "project-configuration", label: "Projects" },
  { key: "client", label: "Clients" },
];

const TimeSheetGeneralSettings = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  // The index route has no segment of its own, so anything that is not one of
  // the named children is the first group.
  const tail = pathname.replace(BASE, "").replace(/^\//, "");
  const active = GROUPS.some((g) => g.key === tail) ? tail : "";

  return (
    <Box sx={{ width: "100%" }}>
      <Topbar MainHeading={"Timesheet settings"} />
      <MainBox sx={{ padding: "1.75rem" }}>
        <SettingsHeader
          title="Timesheet settings"
          subtitle="How hours are logged, checked and billed."
        />
        <SettingsLayout
          groups={GROUPS}
          active={active}
          onSelect={(key) => navigate(key ? `${BASE}/${key}` : BASE)}
        >
          <Outlet />
        </SettingsLayout>
      </MainBox>
    </Box>
  );
};

export default TimeSheetGeneralSettings;
